/* eslint-disable prettier/prettier */
/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './ViewToggle.module.css';

export type ViewMode = 'week' | 'month';

interface ViewToggleProps {
	value: ViewMode;
	onChange: (value: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange }) => {
	return (
		<div className={styles.container}>
			<button
				className={`${styles.option} ${
					value === 'week' ? styles.active : ''
				}`}
				onClick={() => onChange('week')}
			>
				Week
			</button>

			<button
				className={`${styles.option} ${
					value === 'month' ? styles.active : ''
				}`}
				onClick={() => onChange('month')}
			>
				Month
			</button>
		</div>
	);
};

export default ViewToggle;
